import { ContactSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useCRMContactsQuery = createQueryHook(
  'crm.contacts',
  (params: {
    searchTerm?: string;
    sorting?: ContactSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    contacts: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        fullName: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.contacts.entries.map((contact) => ({
        id: contact.id,
        name: contact.fullName,
      })) ?? [],
  },
);
